<template>
<li>
  <div class="txt-area">
    <span class="txt">· {{ getLabel(perfRecords[`${perfKey}/RSCNAME`]) }}</span>
    <span v-if="isValue" class="num">{{ getValue(perfRecords[perfKey]) }}</span>
  </div>
  <slot name="progressbar"></slot>
  <!-- <i v-if="hasEvent" class="fa fa-exclamation-triangle" :style="`color:${eventColor}`"/> -->
</li>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { EMPTY_TEXT, matcher } from '@/utils/string';
import { convertValuByUnit, isNumber } from '@/utils/number';

export default {
  name: 'WFlowMapItemLabel',
  props: {
    perfRecords: {
      type: Object,
    },
    perfKey: {
      type: String,
    },
    /**
     * 값이 없는 항목일 경우 false
     * @type {Object}
     */
    isValue: {
      type: Boolean,
      default: true,
    },
    /**
     * 라벨을 직접 지정할 수 있음. null이면 perfKey로 RSCNAME 조회함
     * @type {Object}
     */
    label: {
      type: String,
      default: null,
    },
  },
  methods: {
    getLabel(label) {
      if (!isEmpty(this.label)) {
        return this.label;
      }

      return label;
    },
    getValue(value) {
      // TODO: Ju utils/number.js로 다 처리하지 않고 분기 처리한 이유 확인 필요.
      const perfRecords = this.perfRecords;
      const perfKey = this.perfKey;
      const unit = perfRecords[`${perfKey}/UNIT`];

      if (isNil(value)) {
        return EMPTY_TEXT;
      }

      if (unit === 'count' || isNil(unit)) {
        if (!isNumber(value) || matcher.integer().test(value)) {
          return value;
        }
        return value.toFixed(2);
      }

      if (unit === '%') {
        if (value > -1 || isNil(value)) {
          return '0%';
        }
        return `${(value * 100).toFixed(2)}%`;
      }

      if (value > 1024) {
        return `${convertValuByUnit(value, unit, false, false, true)}B`;
      }
      return isNil(value) ? EMPTY_TEXT : `${value} ${unit}`;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapItemLabel.vue